import {connect} from 'react-redux';
import {StepSelect as Component} from './StepSelect';
import {
  selectDropdownOption,
  submitQuestionAnswer,
} from '@learningblocks/exp-redux/lib/Actions';

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onDropdownSelect: (params) => {
      dispatch(selectDropdownOption(params));
    },
    submitAnswer: (id, type) => {
      dispatch(submitQuestionAnswer(id, type));
    },
  };
}
const StepSelect = connect(mapStateToProps, mapDispatchToProps)(Component);

export {StepSelect as StepSelectWithRedux, Component as StepSelect};
